import React, { useState } from 'react'
import { IconButton, InputAdornment, OutlinedInput, InputLabel, FormControl } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'


export const PasswordField = props => {
  
  const [showPassword, setShowPassword] = useState(false)
  
  return (
    <FormControl fullWidth margin='normal'>
      <InputLabel htmlFor='password'>Mot de passe</InputLabel>
      <OutlinedInput
        id='password'
        name='password'
        type={showPassword ? 'text' : 'password'}
        label='Mot de passe'
        margin='dense'
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label={showPassword ? 'hide' : 'show'}
              onClick={() => setShowPassword(val => !val)}
              edge='end'
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        inputProps={{ sx: { py: 1 } }}
        {...props}
      />
    </FormControl>
  )
}

export default PasswordField
